module.exports = __webpack_public_path__ + "media/images/pet-1710a8922e527005d68e68808894ec5f.jpeg";